<!-- 连连开户激活 -->
<template>
  <el-dialog title="连连开户激活" :visible="visible" width="500px" :before-close="onClose" v-loading="loading"
    append-to-body>
    <el-form ref="formRef" :model="formData" label-width="auto">
        <el-form-item label="连连密码" prop="password">
          <el-button @click="llpayPwd">
            <span v-if="formData.password">点击输入连连密码</span>
            <span v-else>密码已输入，点击重新输入</span>
          </el-button>
        </el-form-item>
        <el-form-item label="短信验证码" prop="verifyCode">
          <el-button :disabled="!formData.password" @click="getVCode">
            <span v-if="sendVerifyCodeTiemOut>0">{{sendVerifyCodeTiemOut}}秒</span>
            <span v-else>获取验证码</span>
          </el-button>
          <el-input class="margin-top-sm" :disabled="!formData.token" v-model="formData.verifyCode" placeholder="请输入" />
        </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">关 闭</el-button>
      <el-button type="primary" :disabled="!formData.token" @click="onSave">激 活</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { GetApplyPasswordElement,OpenacctActivateApply,OpenacctActivateVerify } from '@/api'
  export default {
    name: "LLpayMechantActity",
    props: {
    },
    data() {
      return {
        visible: false,
        loading: false,
        shop:{},
        formData:{
          password: undefined,
          randomKey: undefined,
          token: undefined,
          verifyCode: undefined,
          txnSeqno: undefined,
        },
        sendVerifyCodeTiemOut: 0,
      }
    },
    methods: {
      onSave(){
        OpenacctActivateVerify({shopId:this.shop.id,token:this.formData.token,verifyCode:this.formData.verifyCode,txnSeqno:this.formData.txnSeqno}).then(res=>{
          if(res.open_account_will_url){
            this.$confirm('还需要你签署开户意愿，是否现在签署?PS: 法人手机号和用户注册手机号也会同步收到签署短信。', '提示', {
              confirmButtonText: '立即签署',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(res2=>{
              this.$message.success("发送成功，现在请签署协议")
              window.open(res.open_account_will_url, '_blank')
            }).catch(()=>{
              this.onClose()
            })
          } else {
            this.$message.error("签署异常，请联系技术")
          }
        })
      },
      onClose(){
        this.visible = false
        this.formData = {
          password: undefined,
          randomKey: undefined,
          token: undefined,
          verifyCode: undefined,
          txnSeqno: undefined,
        }
        this.$emit("close")
      },
      open(shop){
        this.visible = true
        this.shop = shop
      },
      getVCode(){
        OpenacctActivateApply({shopId:this.shop.id,password:this.formData.password,randomKey:this.formData.randomKey}).then(res=>{
          this.formData.token = res.token
          this.formData.txnSeqno = res.txn_seqno
          this.$message.success("短信发送成功")
          this.sendVerifyCodeTiemOut = 60
          const it = setInterval(() => {
            if (this.sendVerifyCodeTiemOut > 0) {
              this.sendVerifyCodeTiemOut = this.sendVerifyCodeTiemOut - 1
            } else {
              clearInterval(it)
            }
          }, 1000)
        })
      },
      llpayPwd(){
        const pwdScene = "setting_password"
        GetApplyPasswordElement({shopId:this.shop.id,pwdScene:pwdScene,flagChnl:"PCH5"}).then(res=>{
          window.lianlianpay.invokePasswordControl(
            {
              // 使用场景
              passwordScene: pwdScene,
              // 商户号
              oidPartner: res.mch_id,
              // 用户号
              userId: 'SHOP_'+this.shop.id,
              // token
              passwordElementToken: res.password_element_token,
              // 环境 ste-测试环境 production-生产环境
              env: 'production',
              // 终端类型 默认根据设备自适应 H5-移动端 PC-桌面端
              terminal: '',
              // 样式配置
              styles: {
                themeColor: '#667eea'
              }
            },
            res => {
              console.log('密码数据', res)
              this.formData.password = res.data.password
              this.formData.randomKey = res.data.randomKey
              this.$message.success("密码输入成功")
            }
          )
        })

      }

    }
  };
</script>

<style lang="scss" scoped>
  .meta-top {
    color: #909399;
    font-size: 12px;
    margin-bottom: 8px;
  }

  .meta-top>span+span {
    margin-left: 20px;
  }

  .block {
    border: 1px solid var(--color-border, #ebeef5);
    border-radius: 8px;
  }

  .detail-grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 0;
    border: 1px solid #ebeef5;
    border-bottom: none;
  }
  ::v-deep .el-card .el-card__header {
      padding: 14px 15px 7px;
      min-height: 40px;
      background: #fafafa;
  }
</style>
